import {
  CREATEACCOUNTPERSONAL,
  DELETEACCOUNTPERSONAL,
  GETACCOUNTPERSONAL,
  UPDATEACCOUNTPERSONAL,
  CREATECUSTOMPRODUCTFORACCOUNT,
  SET_HOSPITAL_CODE,
  GETCUSTOMPRODUCTACCOUNT,
  UPDATECUSTOMPRODUCTACCOUNT,
  SET_SELECTED_ACCOUNT_ID,
  GETCHANNELPARTNERCUSTOMER,
  axios,
  baseURL,
} from "./types";

export const createAccountpersonal = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupaccountpersonal/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "multipart/form-data",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEACCOUNTPERSONAL,
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};

export const getAccountPersonal = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupaccountpersonal/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: GETACCOUNTPERSONAL,
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};

export const updateAccountPersonal = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setupaccountpersonal/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      console.log("✅ UPDATE SUCCESSFUL!", response.data);
      dispatch({ type: UPDATEACCOUNTPERSONAL, payload: response.data });
      return response;
    })
    .catch(function (error) {
      console.error(
        "🔴 API Error:",
        error.response ? error.response.data : error.message,
      );
      throw error;
    });
};
export const deleteAccountPersonal = (data) => (dispatch) => {
  const parsedData = typeof data === "string" ? JSON.parse(data) : data;

  var config = {
    method: "delete",
    url: baseURL + "/api/setupaccountpersonal/deleteAll",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEACCOUNTPERSONAL,
        payload: response.data,
        accountId: parsedData.id,
      });
      return response;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};
export const setHospitalCode = (hospitalCode) => (dispatch) => {
  console.log("✅ Hospital code dispatched to Redux store:", hospitalCode);

  dispatch({
    type: SET_HOSPITAL_CODE,
    payload: hospitalCode,
  });
};

export const createCustomProuctForAccount = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/hospitalAccountCustomProduct/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: CREATECUSTOMPRODUCTFORACCOUNT,
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};

export const getCustomProductForAccount = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/hospitalAccountCustomProduct/getbyhid",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: GETCUSTOMPRODUCTACCOUNT,
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};

export const updateCustomProductAccount = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/hospitalAccountCustomProduct/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,

      "Content-Type": "application/json",
    },

    data: data,
  };

  return axios(config)
    .then(function (response) {
      console.log("✅✅✅ UPDATE SUCCESSFUL! Server Response:", response.data);
      dispatch({
        type: UPDATECUSTOMPRODUCTACCOUNT,
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      if (error.response) {
        console.error("🔴 API Error Response Data:", error.response.data);
        console.error("🔴 API Error Response Status:", error.response.status);
      } else if (error.request) {
        console.error("🔴 API Error Request:", error.request);
      } else {
        console.error("🔴 API Error Message:", error.message);
      }
      throw error;
    });
};

export const setSelectedAccountData = (data) => (dispatch) => {
  console.log("✅ Setting Selected Account Full Data:", data);
  dispatch({
    type: "SET_SELECTED_ACCOUNT_FULL_DATA",
    payload: data,
  });
};

export const getChannelPartnerCustomer = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupaccountpersonal/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: GETCHANNELPARTNERCUSTOMER,
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};
